var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-like-empty"},[_c('img',{attrs:{"src":require("../../assets/images/mypooq/icon-error-74.png"),"alt":""}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }